import { createSlice } from '@reduxjs/toolkit';

import { IGroupsTableList } from 'features/RegulationInventory/api/type-def';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface IregulationInventoryInterface {
	commentCount: number;
	isCommentAdded: boolean;
	isOpenInvententoryCommentDrawer: boolean;
	selectedGroupData: IGroupsTableList | null;
	summaryTextForReview: string | null;
	regInvSelectedTab: number;
	regInvLandingSelectedTab: string;
	regInvSelectedToggleButton: string;
	showAssignedToMeChecked: boolean;
	regInventoryAppliedFilters: any;
	regInventorySearchText: string;
	regInvAISummaryRegenerated: boolean;
}

const initialState: IregulationInventoryInterface = {
	commentCount: 0,
	isCommentAdded: false,
	isOpenInvententoryCommentDrawer: false,
	selectedGroupData: null,
	summaryTextForReview: null,
	regInvSelectedTab: 0,
	showAssignedToMeChecked: false,
	regInventorySearchText: '',
	regInventoryAppliedFilters: [],
	regInvSelectedToggleButton: 'regulations',
	regInvLandingSelectedTab: 'Current Inventory',
	regInvAISummaryRegenerated: false,
};

export const regulationInventorySlice = createSlice({
	name: 'regulationInventory',
	initialState,
	reducers: {
		setCommentCount: (state, action: PayloadAction<number>) => {
			state.commentCount = action.payload;
		},
		setIsCommentAdded: (state, action: PayloadAction<boolean>) => {
			state.isCommentAdded = action.payload;
		},
		setIsOpenInvententoryCommentDrawer: (
			state,
			action: PayloadAction<boolean>,
		) => {
			state.isOpenInvententoryCommentDrawer = action.payload;
		},
		setSelectedGroupData: (
			state,
			action: PayloadAction<IGroupsTableList | null>,
		) => {
			state.selectedGroupData = action.payload;
		},
		setSummaryTextForReview: (state, action: PayloadAction<string | null>) => {
			state.summaryTextForReview = action.payload;
		},
		setRegInvSelectedTab: (state, action: PayloadAction<number>) => {
			state.regInvSelectedTab = action.payload;
		},
		setRegulationToggleButton: (state, action: PayloadAction<string>) => {
			state.regInvSelectedToggleButton = action.payload;
		},
		setRegInventorySearchText: (state, action: PayloadAction<string>) => {
			state.regInventorySearchText = action.payload;
		},
		setRegInventoryAppliedFilters: (state, action: PayloadAction<any>) => {
			state.regInventoryAppliedFilters = action.payload;
		},
		setRegInvLandingSelectedTab: (state, action: PayloadAction<string>) => {
			state.regInvLandingSelectedTab = action.payload;
		},
		setRegInvSummaryRegenerated: (state, action: PayloadAction<boolean>) => {
			state.regInvAISummaryRegenerated = action.payload;
		},
		setShowAssignedToMeChecked: (state, action: PayloadAction<boolean>) => {
			state.showAssignedToMeChecked = action.payload;
		},
	},
});

export const {
	setCommentCount,
	setIsCommentAdded,
	setIsOpenInvententoryCommentDrawer,
	setSelectedGroupData,
	setSummaryTextForReview,
	setRegInvSelectedTab,
	setRegulationToggleButton,
	setRegInventorySearchText,
	setRegInventoryAppliedFilters,
	setRegInvLandingSelectedTab,
	setRegInvSummaryRegenerated,
	setShowAssignedToMeChecked,
} = regulationInventorySlice.actions;
export default regulationInventorySlice.reducer;
